import {lazy, Suspense} from 'react'

import {Loading} from '@sdox/ui'
import {EmptyPanelPlaceholder} from '@sdox/editor'

import {Block} from '../'
import {useIsEditable} from '../../DragAndDrop'

import type {ApolloError} from '@apollo/client'
import type {XcNwBlockFragment} from '@sdox/api'

const DroppablePanel = lazy(() => import('../../DragAndDrop/DroppablePanel'))

interface BlockAccordionSectionItemsProps {
  blocks?: XcNwBlockFragment[]
  loading?: boolean
  error?: ApolloError
}

export const BlockAccordionSectionItems = (props: BlockAccordionSectionItemsProps) => {
  const {blocks, loading, error} = props
  const isEditable = useIsEditable()

  if (error) return <div>There was an error loading the items. Please try again later.</div>
  if (loading) return <Loading />

  const blockElements = blocks?.map((block) => (
    <Block
      key={block.id}
      {...block}
    />
  )) ?? []

  if (!isEditable) {
    return blockElements
  }

  // Add drag and drop capability for editor
  return (
    <Suspense fallback={<Loading />}>
      <DroppablePanel>
        {blockElements.length > 0 && (
          <div className={'grid gap-spacing-32'}>
            {blockElements}
          </div>
        )}
        {blockElements.length === 0 && <EmptyPanelPlaceholder />}
      </DroppablePanel>
    </Suspense>
  )
}
